import React from 'react';
import fb from './ScriptLoader';

class FacebookChat extends React.PureComponent {
  componentDidMount() {
    this.timeout = setTimeout(() => {
      fb(FB => this.timeout && FB.XFBML.parse());
    }, 2000);
  }

  componentWillUnmount() {
    clearTimeout(this.timeout);
    delete this.timeout;
  }

  render() {
    return (
      <div
        className="fb-customerchat"
        attribution="setup_tool"
        page_id="1554157068222377"
      />
    );
  }
}

export default FacebookChat;



// WEBPACK FOOTER //
// ./src/components/FacebookChat/index.js